import { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from 'data/utils/useQuery';
import { HealthDumpControllerService } from 'data/openapi';
import { QueryKeys } from 'data/constants';

export const useExecuteHealthDump = (name: string, options?: UseQueryOptions<Blob, unknown, any>) => {
  return useQuery([QueryKeys.HEALTH_DUMP_FILE, name], () => HealthDumpControllerService.executeHealthDump(name), {
    ...options,
  });
};
